import { useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import { isStaff, useAuth } from "../auth.js";
import { MessageAlerts } from "./MessageAlerts.js";

const promptKey = (accountId: string) => `wmf-message-alert-prompt-v1:${accountId}`;
function wasDismissed(accountId: string): boolean {
  try { return localStorage.getItem(promptKey(accountId)) === "dismissed"; }
  catch { return false; }
}

function Invitation({ accountId }: { accountId: string }) {
  const [dismissed, setDismissed] = useState(() => wasDismissed(accountId));
  const dismiss = useCallback(() => {
    try { localStorage.setItem(promptKey(accountId), "dismissed"); }
    catch { /* The invitation can still close when browser storage is unavailable. */ }
    setDismissed(true);
  }, [accountId]);
  if (dismissed) return null;
  return <MessageAlerts accountId={accountId} invitation onDismiss={dismiss} onEnabled={dismiss} />;
}

/** One invitation per staff account on this browser; notification permission remains opt-in. */
export function TutorMessageAlertsPrompt() {
  const { me } = useAuth();
  const { pathname } = useLocation();
  // The Inbox list already has the full device setting in view.
  if (!me?.verified || !isStaff(me) || /^\/inbox\/?$/.test(pathname)) return null;
  return <Invitation key={me.user.id} accountId={me.user.id} />;
}
